import React, {memo, useCallback, useEffect, useState} from 'react';

import './index.scss';
import {Container} from '../../components/Container';
import yellowDoorIcon from '../../assets/images/icons/intercom/door_open1_icon.png';
import blueDoorIcon from '../../assets/images/icons/intercom/door_open2_icon.png';
import pingDoorIcon from '../../assets/images/icons/intercom/door_open3_icon.png';
import limeDoorIcon from '../../assets/images/icons/intercom/door_open4_icon.png';
import {setEntityListAction, setIntercomInfoAction, setIntercomStatusAction} from '../../store/control/actions';
import {IntercomModel} from '../../types/intercom';
import {useRPC} from '../../hooks/rpc';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {CameraRenderer} from '../../components/CameraRenderer';
import {useLocalization} from "../../hooks/localization";
import {groupSettingAction} from "../../store/ui/actions";
//import { useMessage } from '../../hooks/message';
//import { useHistory } from 'react-router-dom';

const doors = [yellowDoorIcon, blueDoorIcon, pingDoorIcon, limeDoorIcon];
const colors = ['yellow', 'blue', 'pink', 'lime'];

export const IntercomScreen = memo(function IntercomScreen() {
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const {t} = useLocalization();
    //const {failure} = useMessage()
    //const intercomCallTime = useSelector(state => state.control.callTime)
    const intercomList = useSelector(state => state.control.intercomList);
    const intercomState = useSelector(state => state.control.intercomState);
    const [disabledLookup, setDisabledLookup] = useState({});
    //const [isAllowedAccessCamera, setIsAllowedAccessCamera] = useState(false)
    //const history = useHistory()

    const click = useCallback((intercom: IntercomModel) => {
        dispatch(setIntercomInfoAction(intercom));
        dispatch(setIntercomStatusAction('special',true));
    }, [dispatch]);

    useEffect(()=>{
        dispatch(groupSettingAction({visible: false}));
    })

    const openDoor = useCallback((e: React.MouseEvent<HTMLDivElement>, intercom: IntercomModel, info: number) => {
        e.stopPropagation();
        if (disabledLookup[intercom.door_id_list[0]]) {
            return;
        }

        rpc.openDoor(intercom.door_id_list[0])
        setDisabledLookup(lookup => ({
            ...lookup,
            [intercom.door_id_list[0]]: true,
        }));

        setTimeout(() => {
            setDisabledLookup(lookup => ({
                ...lookup,
                [intercom.door_id_list[0]]: false,
            }));
        }, 3000);
    }, [disabledLookup, rpc]);

     useEffect(() => {
         rpc.getIntercomList().then(intercom => dispatch(setEntityListAction(intercom, "intercom")))
         /*rpc.checkUserAuthorization().then(data => {
            if (data) {
                setIsAllowedAccessCamera(data)
                history.push("/")
                failure(t("unauthorized"))
            }
         })*/
     }, [rpc, dispatch /*t, failure, rpc, history*/])


    if (intercomState.status === 'special' || (intercomState.status === 'incoming')) {
        return null;
    }



    return (
        <Container>
            <div className="page-wrapper">
                <div className="intercom-parent">
                    {
                        intercomList.map((intercom, index) => (
                            <div key={`intercom_${intercom.id}`} className="intercom-image-parent"
                                 {...onClickHandler(() => click(intercom))}>
                                <CameraRenderer
                                    className="preview"
                                    mode="snapshot"
                                    id={intercom.camera_id}
                                    quality={360}/>
                                {
                                    renderIf(intercom.door_id_list.length > 0)(() =>
                                        <div
                                            className={'bottom-bar ' + colors[index % 4] + (disabledLookup[intercom.door_id_list[0]] ? ' disabled' : '')}>
                                            <span>{intercom.name}</span>
                                            <div {...onClickHandler((e) => openDoor(e, intercom, intercomState?.call_time))}>
                                                <img src={doors[index % 4]} alt=""/>
                                                <span>{t('OPEN_THE_DOOR')}</span>
                                            </div>
                                        </div>,
                                    )
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </Container>
    );
});
